export const CMEditor = {
    dsn: 'https://e788f1b6d7b54d3482c54d1e27b95f38@sentry.wixpress.com/165',
};
export const CMMyAccount = {
    dsn: 'https://bd7df26433634b41b7e711922156bff7@sentry.wixpress.com/166',
};
export const DBSMEditor = {
    dsn: 'https://adc03f08d1814b5a835f586aaba9d8ff@sentry.wixpress.com/159',
};
export const DBSMViewer = {
    dsn: 'https://27180ecd50484e4eafe543b40d29866d@sentry.wixpress.com/89',
};
export const UserErrors = {
    dsn: 'https://73a0410004ae41b7b60ca1c4b4684996@sentry.wixpress.com/183',
};
export const WixData = {
    dsn: 'https://9653fbb3e48143d890dba8a09a5a98c6@sentry.wixpress.com/184',
};
export const DBSMViewerNext = {
    dsn: 'https://cef68e5a2fd04f08a7c2a02738dbc237@sentry-next.wixpress.com/2411',
};
export const DBSMEditorNext = {
    dsn: 'https://7f23189a6c7a4329936b36eef60054eb@sentry-next.wixpress.com/995',
};
//# sourceMappingURL=sentryProjects.js.map